import { render } from "./cashier_history.vue?vue&type=template&id=36690528&scoped=true"
import script from "./cashier_history.vue?vue&type=script&lang=js"
export * from "./cashier_history.vue?vue&type=script&lang=js"

import "./cashier_history.vue?vue&type=style&index=0&id=36690528&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36690528"]])

export default __exports__